import * as React from 'react';
import { getShopSearchResults, getSelectedSearchedShop } from 'modules/search/shopsearchresults';
import { IShopSearchResultsAction, IShopSearchResultsData } from 'models/search/shopsearchresults';
import { IStore } from 'redux/IStore';
import { IShopListItem } from 'models/shop/shoplistitem';
import { INodeData } from 'models/common';
import { EntitySearch } from 'components';
import { ErrorPage } from 'containers';
import { IModalAction } from 'models/modal';
import { IFetchDefault } from 'modules/fetch';
import { IInfiniteScrollProps } from 'models/infinitescroll';
import * as c from 'models/constants';
import { translate } from 'react-i18next';
import { IUserLanguage } from 'models/user/userlanguage';
const { connect } = require('react-redux');

interface IProps {
	shopSearchResultsData?: IShopSearchResultsData;
	userLanguage?: IUserLanguage;
	fetchDefault: IFetchDefault;
	closeModal: Redux.ActionCreator<IModalAction>;
	getShopSearchResults?: Redux.ActionCreator<IShopSearchResultsAction>;
	getSelectedSearchedShop?: Redux.ActionCreator<IShopSearchResultsAction>;
	showHeaderCloseButton?: boolean;

	selectShop?: (pickerData?: IShopListItem) => void;
	t?: (key: string) => string;
}

@connect(
	(state: IStore) => ({
		shopSearchResultsData: state.shopSearchResults,
		fetchDefault: state.fetchDefault,
		userLanguage: state.userLanguage,
	}),
	(dispatch) => ({
		getShopSearchResults: (isFirstLoad: boolean, keyword: string) =>
			dispatch(getShopSearchResults(isFirstLoad, keyword)),
		getSelectedSearchedShop: (id: string) => dispatch(getSelectedSearchedShop(id)),
	}),
)
@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
class SearchShops extends React.Component<IProps, any> {
	private selectedShopId = '';
	private searchShopsValue = '';

	constructor(props) {
		super(props);

		this.selectedShopId = '';
		this.searchShopsValue = '';

		this.onSubmit = this.onSubmit.bind(this);
		this.cancelClick = this.cancelClick.bind(this);
		this.onShopIdChange = this.onShopIdChange.bind(this);
		this.loadMoreData = this.loadMoreData.bind(this);
		this.onSearchShopsValueChange = this.onSearchShopsValueChange.bind(this);
		this.searchShops = this.searchShops.bind(this);
	}

	public componentDidMount() {
		this.props.getShopSearchResults(true, null);
	}

	public loadMoreData() {
		this.props.getShopSearchResults(false, this.props.shopSearchResultsData.lastSearchedKeyword);
	}

	public onSubmit() {
		if (!this.selectedShopId) {
			alert(this.props.t('SearchShops_Validation'));
			return;
		}
		this.props.selectShop(this.props.shopSearchResultsData.selectedSearchedShop);
	}

	private cancelClick() {
		this.props.closeModal();
	}

	private onShopIdChange(event: any) {
		this.selectedShopId = event.target.value;
		this.props.getSelectedSearchedShop(this.selectedShopId);
		this.forceUpdate();
	}

	private onSearchShopsValueChange(e: any) {
		const value: string = e.target.value;
		this.searchShopsValue = value.length > 0 ? value : null;
		this.forceUpdate();
	}

	private searchShops() {
		this.props.getShopSearchResults(true, this.searchShopsValue);
	}

	public render() {
		if (this.props.shopSearchResultsData.error) {
			return <ErrorPage {...this.props} message={this.props.shopSearchResultsData.message} />;
		}
		const { items, itemsPage, isFetching } = this.props.shopSearchResultsData;
		const { t, showHeaderCloseButton, closeModal } = this.props;

		const radioButtonInputs = items.map((item: IShopListItem) => {
			const entityIdObj: INodeData = JSON.parse(item.entityId);
			return (
				<div key={entityIdObj.id}>
					<label>
						<input
							key={entityIdObj.id}
							type="radio"
							name="shopId"
							value={entityIdObj.id}
							onChange={this.onShopIdChange}
							checked={entityIdObj.id === this.selectedShopId}
						/>
						{item.name}
					</label>
				</div>
			);
		});

		const infiniteScrollProps: IInfiniteScrollProps = {
			dataLength: items.length,
			next: this.loadMoreData,
			hasMore: itemsPage.totalItems > items.length,
			loader: <h4>{t('BSPortal_Common_Loading')}</h4>,
			height: 200,
		};

		let renderLoader = false;
		if (isFetching) {
			renderLoader = true;
		}

		return (
			<EntitySearch
				title={t('SearchShops_Title')}
				placeholder={t('BSPortal_Common_Search')}
				searchValue={this.searchShopsValue}
				onSearchValueChange={this.onSearchShopsValueChange}
				infiniteScrollProps={infiniteScrollProps}
				showHeaderCloseButton={showHeaderCloseButton}
				closeModal={closeModal}
				renderLoader={renderLoader}
				loaderText={t('BSPortal_Common_Loading')}
				radioButtonInputs={radioButtonInputs}
				searchButtonText={t('BSPortal_Common_Search')}
				okButtonText={t('BSPortal_Common_OK')}
				searchFunction={this.searchShops}
				onSubmit={this.onSubmit}
			/>
		);
	}
}

export { SearchShops };
